import axios from 'axios';
import config from '../config';

export default {
    getUnsubscribers(currentPage, perPage, category_id, email) {
        return axios.get(config.publicPath + 'unsubscribers', {
            params: {
                _page: currentPage,
                itemsPerPage: perPage,
                "category.id": category_id,
                "email.email": email
            },
            headers: {
                'Content-Type': 'application/json'
            }
        });
    },
    createUnsubscriber(formData) {
        return axios.post(config.publicPath + 'unsubscribers', formData, {
            headers: {
                'Content-Type': 'multipart/form-data',
                'Accept': 'application/json'
            },
            validateStatus: function (status) {
                return status >= 200 && status < 500;
            },
        });
    },
    deleteUnsubscriber(id) {
        return axios.delete(config.publicPath + 'unsubscribers/' + id);
    }
}